import {ESopLicenses} from "@/components/license/models";
import license from "@/services/license";
import {EDeviceClasses, IDeviceId} from "@toolbox/models";
import {IAdvancedDevice, ISopLimits} from "./models";

import {
    hasLightFactor,
    hasRotation,
    hasSingleChannel,
    hasTemperatureControl,
    hasTilt,
} from "@toolbox/functions/device-check";

export function showWavelengthSelection(
    limits: ISopLimits | undefined,
    deviceClass: EDeviceClasses,
) {
    return (
        !hasSingleChannel(deviceClass) &&
        !!(limits && limits.wavelengths.length > 1)
    );
}

export function getLimits(device?: IAdvancedDevice | IDeviceId): ISopLimits {
    const {sops} = license.status;
    const limits: ISopLimits = {
        maxDuration: 42 * 3600,
        maxProfiles: 1000,
        maxGlobalProfiles: 1000,
        minDuration: 0.3,

        interval: [5, 1500],
        level: [0, 4000],
        lightFactor: [0.25, 4],
        temperature: [0, 40],
        wavelengths: [],

        temperatureRamp: false,
        hasLightFactor: false,
        hasRotation: false,
        hasTilt: false,
        hasTemp: false,
    };

    if (device) {
        // advanced device parameters
        if ("capacity" in device) {
            limits.lightFactor = [device.minLf, device.maxLf];
            limits.level = [device.minLevel, device.maxLevel];
            limits.temperature = [device.minTemp, device.maxTemp];
            limits.interval = [device.minInterval, device.maxInterval];
            limits.wavelengths = device.wavelengths;
        }

        limits.hasLightFactor = hasLightFactor(device.deviceClass);
        limits.hasRotation = hasRotation(device.deviceClass);
        limits.hasTilt = hasTilt(device.deviceClass);

        if (!limits.hasTilt && !limits.hasRotation) {
            // limits.level holds
            // tilt_range for lumi-reader (hasTilt)
            // or
            // rotation-speed_range (hasRotation) for lumi-sizer
            // every other device has none, event if it says so (#4125)
            limits.level = [0, 0];
        }

        limits.hasTemp = hasTemperatureControl(device);

        if (hasSingleChannel(device.deviceClass)) {
            limits.maxDuration = 1000 * 1500; // 416 hours
        } else {
            if (sops.includes(ESopLicenses.Fast)) {
                limits.interval[0] = 0;
            }

            if (sops.includes(ESopLicenses.Long)) {
                limits.maxDuration = Math.max(limits.maxDuration, 99 * 3600);
            }
        }
    }

    if (sops.includes(ESopLicenses.Unlimited)) {
        limits.maxDuration = Number.MAX_SAFE_INTEGER;
        limits.maxGlobalProfiles = Number.MAX_SAFE_INTEGER;
        limits.maxProfiles = Number.MAX_SAFE_INTEGER;
        limits.interval[1] = Number.MAX_SAFE_INTEGER;
    }

    if (sops.includes(ESopLicenses.TemperatureRamp)) {
        limits.temperatureRamp = true; // temp is now local & per cycle
    }

    return limits;
}
